import { Component, input, output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "adaa-form-action-buttons",
  imports: [TranslatePipe],
  templateUrl: "./form-action-buttons.html",
  styleUrl: "./form-action-buttons.scss",
})
export class FormActionButtonsComponent {
  cancelButtonTitle = input<string>("common.form.button.cancel");
  saveButtonTitle = input<string>("common.form.button.save");
  saveButtonDisabled = input<boolean>(false);

  cancelClicked = output<void>();
  saveClicked = output<void>();

  showSaveButton = input<boolean>(true);
}
